import Component from "./component";

class Transport extends Component {
  constructor() {
    super();
    this.boat = false;
  }

  finishSailing() {
    this.boat = false;
  }

  startSailing(boat) {
    this.boat = boat;
  }

  isSailing() {
    return this.boat !== false;
  }

  isWalking() {
    return this.boat === false;
  }
}

export default Transport;
